import { Button } from './ui/button';
import { cn } from '@/lib/utils';

export const Buttons: React.FC<React.ComponentProps<typeof Button>> = ({ children, ...props }) => {
  return (
    <Button
      {...props}
      className={cn(
        'bg-linear-to-r from-teal-600 to-blue-800 text-white w-full',
        'shadow-lg shadow-blue-900/10 transition-all active:scale-95',
        'flex items-center justify-center gap-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'disabled:bg-gray-400 disabled:text-gray-200',
        'disabled:hover:from-teal-600 disabled:hover:to-blue-800',
        'disabled:shadow-none',
        'disabled:active:scale-100',
        props.className
      )}
    >
      {children}
    </Button>
  );
};
